import { SelectedPartAction, ServiceProposalPartAction } from "@repo/common"
import { sortPartActions } from "@repo/ui/lib/part-action-utils"
import {
  getPackagePartActionSelection,
  togglePackagePartAction,
  updatePackagePartActionProductDecision,
  updatePackagePartActionsWithSelectedProducts,
} from "@repo/ui/lib/product-choice-utils"
import { useFieldContext } from "../hooks/form-contexts"
import { ServiceProposalPartActionCard } from "./service-proposal-part-action-card"

export interface ServiceProposalPackagePartActionsFieldProps {
  packagePartActions: ServiceProposalPartAction[]
  originalPackageId: string
}

export const ServiceProposalPackagePartActionsField = ({
  packagePartActions,
  originalPackageId,
}: ServiceProposalPackagePartActionsFieldProps) => {
  const field = useFieldContext<{
    originalPackageId: string
    selectedPartActions: SelectedPartAction[]
    selectedWashOriginalId?: string | undefined
  }>()

  const currentPackage = field.state.value
  const isThisPackage = currentPackage.originalPackageId === originalPackageId
  const selectedPartActions = isThisPackage
    ? currentPackage.selectedPartActions
    : []

  const updatedPartActions =
    updatePackagePartActionsWithSelectedProducts(packagePartActions)

  const { removedPartIds } = getPackagePartActionSelection(
    packagePartActions,
    selectedPartActions,
  )

  return (
    <div className="space-y-4">
      {sortPartActions(updatedPartActions).map((partAction) => {
        const isRemoved = removedPartIds.includes(partAction.partId)

        // Get the product decisions for this specific part action
        const partActionDecisions =
          selectedPartActions.find((pa) => pa.partId === partAction.partId)
            ?.productDecisions || {}

        return (
          <ServiceProposalPartActionCard
            key={partAction.partId}
            data={partAction}
            selected={!isRemoved}
            productDecisions={partActionDecisions}
            onSelect={() => {
              if (!isThisPackage || partAction.isApprovedViaReception) return

              const updatedPackage = togglePackagePartAction(
                currentPackage,
                partAction,
                isRemoved,
              )
              field.handleChange(updatedPackage)
            }}
            onProductSelect={(productId: string, choiceId: string) => {
              if (!isThisPackage) return

              const updatedPackage = updatePackagePartActionProductDecision(
                currentPackage,
                partAction.partId,
                choiceId,
                productId,
              )
              field.handleChange(updatedPackage)
            }}
            interactive={isThisPackage}
            withinPackage={true}
          />
        )
      })}
    </div>
  )
}
